import React, { useState } from 'react';
import { NextPage } from 'next';
import { generateUniqueId } from '../../helper/utils';
import styles from './resource-grid.module.css';
import { ResourceGrid as ResourceGridProp, Taxonomy } from '../../typescript/component';
import CaseStudyGrid from './case-study-grid';
import BlogGrid from './blog-grid';
import ResourceListGrid from './resource-list-grid';

interface ResourceListPageProps {
  resource_grid: ResourceGridProp;
  taxonomies?: Taxonomy[];
  locale: string;
}

const ResourceListPage: NextPage<ResourceListPageProps> = ({
  resource_grid,
  taxonomies,
  locale,
}) => {
  const [localGrid] = useState(resource_grid);

  const renderByType = () => {
    const uniqueKey = `${localGrid._metadata?.uid ?? 'no-id'}${localGrid.title ?? 'no-title'}${locale}`;

    switch (localGrid.component_type) {
      case 'Blog Grid':
        return <BlogGrid key={uniqueKey} resource_grid={localGrid} taxonomies={taxonomies} />;
      case 'Resource Grid':
        return (
          <ResourceListGrid key={uniqueKey} resource_grid={localGrid} taxonomies={taxonomies} />
        );
      case 'Case Study Grid':
        return <CaseStudyGrid key={uniqueKey} resource_grid={localGrid} taxonomies={taxonomies} />;
      default:
        return <BlogGrid key={uniqueKey} resource_grid={localGrid} taxonomies={taxonomies} />;
    }
  };

  const emptyCTAOnly =
    !localGrid.featured_resources?.length &&
    !localGrid.title &&
    !localGrid.eyebrow &&
    !localGrid.description;

  return (
    <div
      id={generateUniqueId(localGrid.anchor || localGrid.title)}
      className={`${styles.resourceGrid} ${emptyCTAOnly ? styles.resourceGridMargin : ''}`}
    >
      {renderByType()}
    </div>
  );
};

export default ResourceListPage;
